import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi) // Charge les fichiers JSON
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Initialise react-i18next
  .init({
    fallbackLng: "fr", // Langue par défaut
    debug: true, // Active les logs pour voir les chargements
    interpolation: {
      escapeValue: false, // Permet d'afficher du HTML
    },
    backend: {
      loadPath: "/locales/{{lng}}.json", // Vérifie bien ce chemin
    },
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"], // Sauvegarde la langue choisie
    },
  });

export default i18n;
